import {
	AlignEndHorizontal,
	Backpack,
	BarChart2,
	Barcode,
	BookCopy,
	Box,
	Boxes,
	Briefcase,
	Building2,
	Calculator,
	CreditCard,
	DownloadCloud,
	FacebookIcon,
	FileAxis3D,
	FileLineChart,
	FileSearch,
	Home,
	Layers,
	LayoutDashboard,
	ListChecks,
	LucideFileLineChart,
	Map,
	Move3d,
	Package,
	Package2,
	PackageCheck,
	PackagePlus,
	Radio,
	Receipt,
	ScanBarcode,
	Settings,
	ShoppingCart,
	Smartphone,
	Truck,
	User,
	User2,
	UserCheck2,
	UserCog,
	Warehouse,
	Wifi,
} from "lucide-react";

export type Org = {
	name: string;
	version: string;
	key: string;
};

export type BaseNav = {
	title: string;
	url?: string;
	icon?: React.ComponentType;
	basePath?: string;
	items?: SubNav[];
	new?: boolean;
	hidden?: boolean;
};

import packageJson from "../package.json";

export interface Nav extends BaseNav {
	role?: string;
	permission?: string;
}

export type SubNav = BaseNav & ({ role?: string } | { permission?: string });

export const orgs = [
	// { name: "Live", key: "live", version: packageJson.version },
	// {
	// 	name: "Live Order",
	// 	key: "live-order",
	// 	version: packageJsonLiveOrder.version,
	// },
	{
		name: "Inventory",
		key: "inventory",
		version: process.env.NODE_ENV === "development" ? `v${packageJson.version}-dev` : `v${packageJson.version}`,
	},
	{
		name: "App Settings",
		key: "app-settings",
		version: process.env.NODE_ENV === "development" ? `v${packageJson.version}-dev` : `v${packageJson.version}`,
	},
	{
		name: "Backend Settings",
		key: "backend-settings",
		version: process.env.NODE_ENV === "development" ? `v${packageJson.version}-dev` : `v${packageJson.version}`,
	}
	// { name: "Yehey App", key: "yehey-app", version: "unreleased" },

] satisfies Org[];

export const nav: Record<string, Nav[]> = {
	inventory: [
		// {
		// 	title: "Home",
		// 	url: "/live-order",
		// 	icon: Home,
		// 	permission: "",
		// },
		{
			title: "Account",
			url: "/account",
			icon: UserCog,
			permission: "",
		},
		{
			title: "Customer",
			url: "/inventory/customer",
			icon: User,
			permission: "",
		},
		{
			title: "Vendor",
			url: "/inventory/vendor",
			icon: Briefcase,
			permission: "",
		},
		{
			title: "Product",
			url: "#",
			icon: Package,
			permission: "",
			items: [
				{
					title: "Category",
					url: "/inventory/category",
					icon: Layers,
				},
				// {
				// 	title: "Product",
				// 	url: "#",
				// 	icon: Package,
				// 	items: [

				// 	],
				// },
				{
					title: "Model",
					url: "/inventory/product-model",
					icon: Package,
				},
				{
					title: "Product",
					url: "/inventory/product",
					icon: Package,
				},
			],
		},
		// {
		// 	title: "Inflow",
		// 	url: "/inventory/inflow",
		// 	icon: DownloadCloud,
		// 	permission: "",
		// 	items: [
		// 		{
		// 			title: "Parser",
		// 			url: "/inventory/inflow/parser",
		// 			icon: FileSearch,
		// 		},
		// 		{
		// 			title: "Inbound",
		// 			url: "/inventory/inflow/inbound",
		// 			icon: PackagePlus,
		// 		},
		// 		{
		// 			title: "Receiving",
		// 			url: "/inventory/inflow/receiving",
		// 			icon: PackageCheck,
		// 		},
		// 		{
		// 			title: "Putaway",
		// 			url: "/inventory/inflow/putaway",
		// 			icon: Move3d,
		// 		},
		// 	],
		// },
		{
			title: "Sales Order",
			icon: Receipt,
			permission: "",
			items: [
				{
					title: "Overview",
					url: "/inventory/sales-order",
					icon: LayoutDashboard,
				},
				{
					title: "Warehouse",
					url: "/inventory/sales-order/warehouse",
					icon: Package,
				},
				{
					title: "Logistic",
					url: "/inventory/sales-order/logistic",
					icon: Truck,
				},
				{
					title: "Payments",
					url: "/inventory/sales-order/payments",
					icon: CreditCard,
				},
				{
					title: "App",
					url: "/inventory/sales-order/app",
					icon: Smartphone,
				},
			],
		},
		{
			title: "Purchase Order",
			url: "/inventory/purchase-order",
			icon: Receipt,
			permission: "",
		},
		{
			title: "Deals",
			url: "/inventory/deals",
			icon: FileLineChart,
			permission: "",
		},
		{
			title: "Live",
			url: "/inventory/live",
			icon: Radio,
			permission: "",
		},
	],
	"app-settings": [
		{
			title: "Live",
			url: "/app-settings/live",
			icon: Radio,
			permission: "",
		},
	],
	"backend-settings": [
		{
			title: "Barcode",
			url: "/backend-settings/barcode",
			icon: Barcode,
		},
		{
			title: "Address",
			icon: Map,
			items: [
				{
					title: "JP Address",
					url: "/backend-settings/address/jp",
					icon: () => ""
				},
				{
					title: "PH Address",
					url: "/backend-settings/address/ph",
					icon: () => ""
				}
			]
		},
		{
			title: "Product Import",
			url: "/backend-settings/product-import",
			icon: Package,
		}
	]
	// "yehey-app": [
	// 	{
	// 		title: "Home Yehey App",
	// 		url: "/report",
	// 		icon: Home,
	// 		permission: "",
	// 	},
	// 	{
	// 		title: "Getting Started",
	// 		url: "#",
	// 		permission: "",
	// 		items: [
	// 			{
	// 				title: "Installation",
	// 				url: "#",
	// 				icon: Backpack,
	// 			},
	// 			{
	// 				title: "Project Structure",
	// 				url: "#",
	// 				icon: Backpack,
	// 			},
	// 		],
	// 	},
	// ],
} satisfies Record<string, Nav[]>;
